import { useDispatch, useSelector } from "react-redux";

import Body from "../Navigation/Body";
import PatientFetch from "./PatientFetch";
import { surveyActions } from "../../actions";
import { useApi } from "../../contexts/ApiProvider";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSurveyMode } from "../../contexts/SurveyModeProvider";
import { useUser } from "../../contexts/UserProvider";

const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

export default function PatientPage() {
  const { user } = useUser();
  const { micro_id } = useParams();
  const api = useApi();
  const { debug_mode } = useSurveyMode();
  const patients = useSelector((state) => state.survey.patients);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user === null) return;
    if (patients !== undefined && !(micro_id in patients)) {
      dispatch(surveyActions.initialiseSurveyPatient(micro_id, debug_mode));
    }
  }, [debug_mode, micro_id]);

  return (
    <Body>
      {" "}
      {user && <PatientFetch key={micro_id} micro_id={micro_id} api={api} />}
    </Body>
  );
}
